import { MutationTree } from 'vuex';
import { State } from './browserCommon.store';
import store from '@/store/index';
import {
  NAVTABS,
  BROWSER_ENTIY
} from '@/utils/templates/Browser/browser.constants';

const mutations: MutationTree<State> = {
  setBrowserTab(state, tabName) {
    switch (tabName) {
      case NAVTABS.BROWSER_APPLICATION_TAB:
        state.currentTab = 'Application';
        break;
      case NAVTABS.BROWSER_PAGE_TAB:
        state.currentTab = 'Pages';
        break;

      case NAVTABS.BROWSER_ERRORS_TAB:
        state.currentTab = 'Errors';
        break;
      default:
        state.currentTab = 'Application';
        break;
    }
  },

  setBrowserServices(state: State, data: any) {
    state.browserServices = data;
    if (!state.currentBrowserService.key && data.length) {
      state.currentBrowserService = data[0];
    }
  },
  setBrowserPages(state: State, data: any) {
    state.browserPages = data;
    if (!state.currentBrowserPage.key && data.length) {
      state.currentBrowserPage = data[0];
    }
  },
  //Sets the current service in rootState
  setCurrentBrowserService(state: State, service: any) {
    state.currentBrowserService = service;
    store.commit('globalState/app/setUpdateDasboard', service, { root: true });
  },
  setCurrentBrowserPage(state: State, page: any) {
    state.currentBrowserPage = page;
    // store.commit('globalState/app/setUpdateDasboard', page, { root: true });
  },
  setCurrentVersion(state: State, version: any) {
    state.currentBrowserVersion = version;
    store.commit('globalState/app/setUpdateDasboard', version, { root: true });
  },
  setSyntheticUser(state: State, value: any) {
    state.syntheticUserEnabled = value;
  },
  
  // resets to default values on logout
  setDefaultValues(state: State, value: any) {
    state.currentTab = '';
    state.capability = '';
    state.browserServices = [];
    state.browserPages = [];
    state.versions = [];
    state.currentBrowserService = {};
    state.currentBrowserVersion = {};
    state.currentBrowserPage = {};
    state.syntheticUserEnabled = false;
  },

  setBrowserApdexEnabled(state: State, value: any) {
    state.browserApdexEnabled = value;
  },
};

export default mutations;
